export enum ItemType {
	Text = "0",
	Video = "1",
  }


export interface ISubChallengeDTO {
	completed: boolean;
	description: string;
	title: string;
	type: ItemType;
	url: string | null;
	urlImage: string | null;
}

export interface IServiceChallenges {
	idChallenge: number;
	userId: number;
	subChallengeDTO: ISubChallengeDTO[];
	description: string;
}

export interface IChallenges {
	idChallenge: number;
	subChallengeDTO: ISubChallengeDTO[]
	index: number;
	description: string;
}

export default function challengesAdapter (challenges: IServiceChallenges[]): IChallenges[] {
	return challenges.map((challenge, idx) => ({
		idChallenge: challenge.idChallenge,
		subChallengeDTO: challenge.subChallengeDTO.map(subChallenge => ({
			completed: subChallenge.completed,
			description: subChallenge.description,
			title: subChallenge.title,
			type: subChallenge.type as ItemType,
			url: subChallenge.url,
			urlImage: subChallenge.urlImage
		})),
		description:challenge.description,
		index: idx,
	}))
}

 